/**
 * Generic tabs component (see sass/components/_tabs.scss).
 * Scope markup with `data-tabs` on the wrapper, `data-tabs-trigger`
 * on each `.tabs-trigger` and `data-tabs-panel` on each
 * `.tabs-panel`, both sharing the same value to pair them up.
 */
const initTabs = () => {
  const groups = document.querySelectorAll('[data-tabs]');

  groups.forEach((group) => {
    const triggers = group.querySelectorAll('.tabs-trigger');
    const panels = group.querySelectorAll('.tabs-panel');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const { tabsTrigger: target } = trigger.dataset;

        triggers.forEach((item) => item.classList.toggle('is-active', item === trigger));
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tabsPanel === target));
      });
    });
  });
};

export default initTabs;
